import { useParams } from "react-router-dom";
import { AnimatedPage, FadeIn } from "../../../../components/AnimatedPage";

import { Tabs, TabsContent } from "../../../../components/ui/tabs";
import { getFundDbName } from "../../../../utils/funds";
import { CheckoutListViewer } from "../../components/checkout-list-viewer";

// Template de uma ops só: as entradas do menu são /checkout-resolution/muve e
// /checkout-resolution/viva. O fundo sai direto da ops, sem passo assíncrono.
export default function GestorCheckoutResolution() {
  const { ops } = useParams<{ ops: string }>();
  const dbName = ops ? getFundDbName(ops) : "";

  // const {
  //   resolutionData,
  //   isLoading,
  //   toast,
  //   handleResolveCheckout,
  //   closeToast,
  //   refetch,
  //   isResolving,
  // } = useCheckoutResolution(selectedDate, selectedFund);

  // useEffect(() => {
  //   if (toast.open) {
  //     setTimeout(() => {
  //       closeToast();
  //     }, 6000);
  //   }
  // }, [toast, closeToast]);

  // const pendingColumns: ColumnDef<CheckoutResolutionData>[] = [
  //   {
  //     accessorKey: "ops",
  //     header: createSortableHeader("Operação"),
  //   },
  //   {
  //     accessorKey: "valor_compra",
  //     header: createSortableHeader("Valor Pendente"),
  //     cell: ({ row }) => {
  //       const value = row.getValue("valor_compra") as number;
  //       return new Intl.NumberFormat("pt-BR", {
  //         style: "currency",
  //         currency: "BRL",
  //       }).format(value / 100);
  //     },
  //   },
  //   {
  //     accessorKey: "pagamentos_unicos",
  //     header: createSortableHeader("Pagamentos"),
  //     cell: ({ row }) => {
  //       const value = row.getValue("pagamentos_unicos") as number;
  //       return value || "0";
  //     },
  //   },
  //   {
  //     accessorKey: "data_romaneio",
  //     header: createSortableHeader("Data Romaneio"),
  //     cell: ({ row }) => {
  //       const value = row.getValue("data_romaneio") as string;
  //       return value ? new Date(value).toLocaleDateString("pt-BR") : "-";
  //     },
  //   },
  //   {
  //     id: "actions",
  //     header: "Ações",
  //     cell: ({ row }) => {
  //       const ops = row.original.ops;
  //       return (
  //         <Button
  //           size="sm"
  //           onClick={() => handleResolveCheckout(ops)}
  //           disabled={isResolving}
  //         >
  //           <CheckCircle className="h-4 w-4 mr-2" />
  //           Resolver
  //         </Button>
  //       );
  //     },
  //   },
  // ];

  // const resolvedColumns: ColumnDef<CheckoutResolutionData>[] = [
  //   {
  //     accessorKey: "ops",
  //     header: createSortableHeader("Operação"),
  //   },
  //   {
  //     accessorKey: "valor_compra",
  //     header: createSortableHeader("Valor Total"),
  //     cell: ({ row }) => {
  //       const value = row.getValue("valor_compra") as number;
  //       return new Intl.NumberFormat("pt-BR", {
  //         style: "currency",
  //         currency: "BRL",
  //       }).format(value / 100);
  //     },
  //   },
  //   {
  //     accessorKey: "pagamentos_unicos",
  //     header: createSortableHeader("Pagamentos"),
  //     cell: ({ row }) => {
  //       const value = row.getValue("pagamentos_unicos") as number;
  //       return value || "0";
  //     },
  //   },
  //   {
  //     accessorKey: "data_romaneio",
  //     header: createSortableHeader("Data Romaneio"),
  //     cell: ({ row }) => {
  //       const value = row.getValue("data_romaneio") as string;
  //       return value ? new Date(value).toLocaleDateString("pt-BR") : "-";
  //     },
  //   },
  // ];

  // const pendingData = resolutionData.pending || [];
  // const resolvedData = resolutionData.resolved || [];
  // const summary = resolutionData.summary || {
  //   totalPending: 0,
  //   totalResolved: 0,
  //   totalValue: 0,
  // };

  return (
    <AnimatedPage className="p-6">
      {/* {toast.open && (
        <FadeIn className="fixed top-4 right-4 z-50 max-w-md">
          <Card
            className={`${
              toast.variant === "destructive"
                ? "border-red-500 bg-red-50"
                : toast.variant === "success"
                  ? "border-green-500 bg-green-50"
                  : "border-blue-500 bg-blue-50"
            }`}
          >
            <CardContent className="p-4">
              <p className="text-sm font-medium">{toast.message}</p>
            </CardContent>
          </Card>
        </FadeIn>
      )} */}

      <FadeIn className="mb-6">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h1 className="text-3xl font-bold text-foreground capitalize">
              Resolução de Checkout {ops ? `- ${ops}` : ""}
            </h1>
            <p className="text-muted-foreground mt-1">
              Gestão e resolução de checkouts pendentes
            </p>
          </div>
          {/* <Button
            variant="outline"
            onClick={() => refetch()}
            disabled={isLoading}
            className="hover:bg-primary/10 transition-colors"
          >
            <RefreshCw
              className={`h-4 w-4 mr-2 ${isLoading ? "animate-spin" : ""}`}
            />
            Atualizar
          </Button> */}
        </div>

      </FadeIn>

      <Tabs defaultValue="list" className="w-full">
        {/* <TabsList className="grid w-full max-w-md grid-cols-2">
          <TabsTrigger value="list">Lista de Checkouts</TabsTrigger>
          <TabsTrigger value="resolution">Resolução</TabsTrigger>
        </TabsList> */}

        <TabsContent value="list" className="mt-6">
          <CheckoutListViewer ops={ops} dbName={dbName} />
        </TabsContent>

        {/* <TabsContent value="resolution" className="mt-6">
          {isLoading ? (
            <>
              <StatBoxSkeleton count={3} />
              <div className="mt-8 space-y-8">
                <SelectFieldSkeleton count={2} />
              </div>
            </>
          ) : (
            <>
              <StaggerChildren staggerDelay={0.05}>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
                  <FadeIn>
                    <StatBox
                      title="Total Pendente"
                      value={summary.totalPending}
                      valueType="integer"
                      icon={<Truck className="h-6 w-6 text-orange-600" />}
                    />
                  </FadeIn>
                  <FadeIn delay={0.05}>
                    <StatBox
                      title="Total Resolvido"
                      value={summary.totalResolved}
                      valueType="integer"
                      icon={<CheckCircle className="h-6 w-6 text-green-600" />}
                    />
                  </FadeIn>
                  <FadeIn delay={0.1}>
                    <StatBox
                      title="Valor Total"
                      value={summary.totalValue}
                      valueType="cents"
                      icon={<DollarSign className="h-6 w-6 text-blue-600" />}
                    />
                  </FadeIn>
                </div>
              </StaggerChildren>

              <div className="space-y-8">
                <DataTable
                  columns={pendingColumns}
                  data={pendingData.map((item, index) => ({
                    ...item,
                    id:
                      `${item.ops}-${item.data_romaneio}` || `pending-${index}`,
                  }))}
                  title="Checkouts Pendentes"
                  loading={isLoading}
                  exportFileName="Checkouts_Pendentes"
                />

                <DataTable
                  columns={resolvedColumns}
                  data={resolvedData.map((item, index) => ({
                    ...item,
                    id:
                      `${item.ops}-${item.data_romaneio}` ||
                      `resolved-${index}`,
                  }))}
                  title="Checkouts Resolvidos"
                  loading={isLoading}
                  exportFileName="Checkouts_Resolvidos"
                />
              </div>
            </>
          )}
        </TabsContent> */}
      </Tabs>
    </AnimatedPage>
  );
}
